import { Reducer } from "redux";

import { MasterServiceProviderResponse } from "../models/api/ServiceProvider";
import { MasterServiceProviderActionDispatchTypes } from "../constants/ServiceProvider";
import { MasterServiceProviderDispatchTypes } from "../models/dispatchTypes/ServiceProvider";

const initialState: MasterServiceProviderResponse = {
  loading: false,
  response: [],
  error: null
};

const MasterServiceProviderReducer: Reducer<
  MasterServiceProviderResponse,
  MasterServiceProviderDispatchTypes
> = (state = initialState, action) => {
  switch (action.type) {
    case MasterServiceProviderActionDispatchTypes.MASTER_SERVICE_PROVIDER_INVOKE: {
      return {
        ...state,
        loading: true,
        error: null,
      };
    }
    case MasterServiceProviderActionDispatchTypes.MASTER_SERVICE_PROVIDER_SUCCESS: {
      return {
        ...state,
        response: action.response,
        loading: false,
        error: null,
      };
    }
    case MasterServiceProviderActionDispatchTypes.MASTER_SERVICE_PROVIDER_ERROR: {
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    }
  }
  return state;
};

export default MasterServiceProviderReducer;
